import React from 'react';
import Button from '../Button';
import { IoMdClose } from 'react-icons/io';

import './style.css';

class ModalConfirm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isMessageOnly: props.isMessageOnly !== undefined ? true : false,
      message: props.message || 'Deseja confirmar esta ação?',
      title: props.title || 'Confirmação',
    };
  }

  render() {
    return (
      <div id="modal-confirm">
        <div className="content-modal-confirm">
          {this.props.onClose !== undefined && (
            <div className="close-modal-confirm" onClick={this.props.onClose}>
              <IoMdClose />
            </div>
          )}

          <div className="title-confirm">{this.state.title}</div>

          <div
            className={`message-confirm${this.state.isMessageOnly ? ' mb-0' : ''}`}
          >
            {this.state.message}
          </div>

          {!this.state.isMessageOnly && (
            <div className="align-buttons-confirm">
              {this.props.onConfirm !== undefined && (
                <Button className="full" onClick={this.props.onConfirm}>
                  Confirmar
                </Button>
              )}
              {this.props.onClose !== undefined && (
                <Button className="full" onClick={this.props.onClose}>
                  Cancelar
                </Button>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default ModalConfirm;
